(() => {
  const form = document.querySelector("form");
  const textArea = document.getElementById("booking-text");
  const submitButton = document.getElementById("submit");
  const statusEl = document.getElementById("status");

  if (!form || !textArea || !submitButton || !statusEl) {
    return;
  }

  const setStatus = (message, tone = "") => {
    statusEl.textContent = message;
    statusEl.classList.remove("error", "success");
    if (tone) {
      statusEl.classList.add(tone);
    }
  };

  const setBusy = (isBusy) => {
    submitButton.disabled = isBusy;
    submitButton.textContent = isBusy ? "Working..." : "Generate .ics";
  };

  const getTurnstileToken = () => {
    const tokenInput = document.querySelector(
      "input[name=\"cf-turnstile-response\"]",
    );
    return tokenInput ? tokenInput.value : "";
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();

    const text = textArea.value.trim();
    if (!text) {
      setStatus("Paste some booking text first.", "error");
      return;
    }

    const token = getTurnstileToken();
    if (!token) {
      setStatus("Please complete the Turnstile check.", "error");
      return;
    }

    setStatus("Submitting...", "");
    setBusy(true);

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text,
          turnstile_token: token,
        }),
      });

      if (!response.ok) {
        const errorPayload = await response.json().catch(() => ({}));
        const message =
          errorPayload.error || "Something went wrong generating your file.";
        throw new Error(message);
      }

      const payload = await response.json();
      if (payload?.url) {
        const anchor = document.createElement("a");
        anchor.href = payload.url;
        anchor.download = "";
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
      }

      setStatus("Submitted. Check logs for the payload.", "success");
    } catch (error) {
      setStatus(
        error instanceof Error ? error.message : "Something went wrong.",
        "error",
      );
    } finally {
      setBusy(false);
    }
  });
})();
